package org.hs_soft.runmynesto.domain.model.home.options.cash_flow

import org.hs_soft.runmynesto.domain.util.Constants
import org.hs_soft.runmynesto.domain.util.helper.LanguageManager

enum class CreditCardsInfoEnum(
    val title: String,
) {

    NAME_1(
        title = "",
    ),
    NAME_2(title = ""),
    NAME_3(
        title = "",
    ),
    NAME_4(title = ""),
    NAME_5(
        title = "",
    ),
    NAME_6(title = ""),
    NAME_7(title = ""),
    NAME_8(title = ""),
    NAME_9(title = ""),
    NAME_10(title = "");

    val titleShown: String
        get() = LanguageManager.getCurrentStrings().let { strings ->
            when (this) {
                NAME_1 -> strings.name1
                NAME_2 -> strings.name2
                NAME_3 -> strings.name3
                NAME_4 -> strings.name4
                NAME_5 -> strings.name5
                NAME_6 -> strings.name6
                NAME_7 -> strings.name7
                NAME_8 -> strings.name8
                NAME_9 -> strings.name9
                NAME_10 -> strings.name10
            }
        }
}